<template>
  <v-row align="start" justify="center">
    <v-col cols="12">
      <subscriptionTable :items="mySubscriptions" />
    </v-col>
  </v-row>
</template>

<script>
import subscriptionTable from "@/components/subscriptions/Table.vue";
// import ApiService from "@/common/api.service";
import { mapGetters } from "vuex";
import { SUBSCRIPTION, ACCOUNT } from "@/store/actions.type";

export default {
  name: "Subscriptions",
  components: {
    subscriptionTable
  },
  props: {},
  data() {
    return {
      mySubscriptions: []
    };
  },
  computed: {
    ...mapGetters(["accounts", "subscriptions", "currentUser"])
  },
  watch: {
    currentUser(currentUser) {
      this.fetchData(currentUser);
    }
  },
  mounted() {
    if (this.currentUser) {
      this.fetchData(this.currentUser);
    }
  },
  methods: {
    async fetchData(currentUser) {
      if (!this.accounts) {
        await this.$store.dispatch(ACCOUNT.FETCH, currentUser.id);
      }
      if (!this.subscriptions) {
        await this.$store.dispatch(SUBSCRIPTION.FETCH, currentUser.id);
      }
      if (this.mySubscriptions.length == 0) {
        this.buildMySubscriptions();
      }
    },
    buildMySubscriptions() {
      if (this.subscriptions) {
        this.subscriptions.forEach(subscription => {
          // find account info
          subscription.traderAccount = this.accounts.filter(
            account => account.id == subscription.traderAccountId
          )[0];
          subscription.investorAccount = this.accounts.filter(
            account => account.id == subscription.investorAccountId
          )[0];
        });
      }
      this.mySubscriptions = this.subscriptions;
    }
  }
};
</script>
<style></style>
